interface SiteSettings {
    siteName: string;
    logo: string;
    favicon: string;
    slides: string[];
    email: string;
    acilisSaati: string;
    kapanisSaati: string;
    instagram: string;
    twitter: string;
    facebook: string;
    metaDescription: string;
    metaKeywords: string;
    metaTitle: string;
    coordinates: string;
}

interface SiteSettingsState {
    siteSettings: SiteSettings | null;
    loading: boolean;
    error: string | null;
}

interface SiteSettingsAction {
    type: string;
    payload?: any;
}

const initialState: SiteSettingsState = {
    siteSettings: null,
    loading: false,
    error: null
}

const siteSettingsReducer = (state: SiteSettingsState = initialState, action: SiteSettingsAction): SiteSettingsState => {
    switch (action.type) {
        case "GET_SITE_SETTINGS_START":
            return {
                ...state,
                loading: true,
                error: null
            }
        case "GET_SITE_SETTINGS_SUCCESS":
            return {
                ...state,
                siteSettings: action.payload as SiteSettings,
                loading: false,
                error: null
            }
        case "GET_SITE_SETTINGS_ERROR":
            return {
                ...state,
                loading: false,
                error: action.payload as string
            }
        case "UPDATE_SITE_SETTINGS_START":
            return {
                ...state,
                loading: true,
                error: null
            }
        case "UPDATE_SITE_SETTINGS_SUCCESS":
            return {
                ...state,
                siteSettings: action.payload as SiteSettings,
                loading: false,
                error: null
            }
        case "UPDATE_SITE_SETTINGS_ERROR":
            return {
                ...state,
                loading: false,
                error: action.payload as string
            }
        case "RESET_SITE_SETTINGS_STATE":
            return initialState;
        default:
            return state;
    }
}

export default siteSettingsReducer;